import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import { BackgroundImage, PrimaryButton } from "../../elements";
import { gtag } from "../../utils";
import "./style.scss";
const BrandList = props => {
  const { lang, rendering, fields, page } = props;
  const { list } = fields;
  const [listData, setListData] = useState([]);
  const isAR = page?.fields?.rtl?.value;

  const toggle = (e, item) => {
    gtag('event', 'Component_info', {
      'component_name': 'BrandList',
      'page_title': page?.name
    });
    let list = JSON.parse(JSON.stringify(listData));
    list.forEach((el) => {
      if (el.id === item.id) {
        el.open = !el.open;
      } else {
        el.open = false;
      }
    })
    setListData(list)
  }

  useEffect(() => {
    let listData = [];
    list.forEach((item, index) => {
      let dataItem = {
        fields: item.fields,
        number: index < 9 ? '0' + (index + 1) : index + 1,
        id: item.id,
        open: false
      }
      listData.push(dataItem);
    })
    setListData(listData);
  }, [])

  const rootClasses = classNames("c-brand-list", isAR ? 'rtl' : '', getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource}>
      <div className="c-brand-list__mobile">
        {listData.map((item, index) => (
          <div className={classNames("c-brand-list__item", item.open ? 'active' : '')} key={item.id} onClick={(e) => toggle(e, item)}>
            <div className={'c-brand-list__item__number'}>{item.number}</div>
            <div className={'c-brand-list__item__content'}>
              <RichText className={'c-brand-list__item__content__title'} tag="div" field={item.fields.title} />
              {item.open && <RichText className={'c-brand-list__item__content__description'} tag="div" field={item?.fields?.description} />}
              {item.open && item?.fields?.image?.value?.src && <img src={item?.fields?.image?.value?.src} className={classNames("c-brand-list__item__content__image", item.open ? 'active' : '')} />}
              {item.open && item?.fields?.button?.fields && <PrimaryButton {...item?.fields?.button?.fields} />}
            </div>
          </div>
        ))}
      </div>
      <div className="c-brand-list__pc">
        {listData.map((item, index) => (
          <div className={classNames("c-brand-list__item", item.open ? 'active' : '')} key={item.id} onClick={(e) => toggle(e, item)}>
            <div className={'c-brand-list__item__number'}>{item.number}</div>
            {item?.fields?.image?.value?.src && <div className={classNames("c-brand-list__item__image", item.open ? 'active' : '')}>
              <BackgroundImage {...item?.fields?.image} />
            </div>}
            <div className={'c-brand-list__item__content'}>
              <div className={'c-brand-list__item__content__detail'}>
                <RichText className={'c-brand-list__item__content__title'} tag="div" field={item.fields.title} />
                {item.open && <RichText className={'c-brand-list__item__content__description'} tag="div" field={item?.fields?.description} />}
              </div>
              {item.open && item?.fields?.button?.fields && <PrimaryButton {...item?.fields?.button?.fields} />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandList;